(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmb-home-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bmb-team-carousel')) {
    customElements.define('bmb-team-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-bmb-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-bmb-index]'));
        this.status = this.querySelector('[data-bmb-status]');
        this.index = 0;
        if (this.slides.length < 2) return;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.dataset.bmbMove !== undefined) this.show(this.index + Number(button.dataset.bmbMove));
          else if (button.dataset.bmbIndex !== undefined) this.show(Number(button.dataset.bmbIndex));
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        });
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
        this.dots.forEach((dot, position) => { dot.setAttribute('aria-pressed', String(position === this.index)); });
        if (this.status) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
